import type { ErrorResponse } from './types'

export function isErrorResponse(data: any): data is ErrorResponse {
    return 'error' in data || 'message' in data || 'errorMessage' in data
}
